/* Hanzo full-screen photo viewer for the regular product pages (Dawn main-product / featured-product galleries).
   Replaces the theme's media modal: click/tap a product photo -> dark full-screen viewer, one photo at a time,
   swipe or arrows, "3 / 7" counter, Esc / × / click beside the photo closes. Same look as the plateful (hzb) pages.
   Loaded from layout/theme.liquid. 2026-10-21. */
(function () {
  if (window.__hzLightbox) return;
  window.__hzLightbox = true;

  var lang = (document.documentElement.lang || '').slice(0, 2);
  var T = {
    lt: ['Uždaryti', 'Ankstesnė nuotrauka', 'Kita nuotrauka'],
    et: ['Sulge', 'Eelmine pilt', 'Järgmine pilt'],
    lv: ['Aizvērt', 'Iepriekšējais attēls', 'Nākamais attēls'],
  }[lang] || ['Uždaryti', 'Ankstesnė nuotrauka', 'Kita nuotrauka'];

  var css = '.hz-lb{position:fixed;inset:0;z-index:2147483000;background:rgba(24,21,19,.94);display:none}'
    + '.hz-lb.is-open{display:block}'
    + '.hz-lb__track{display:flex;width:100%;height:100%;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;overscroll-behavior:contain}'
    + '.hz-lb__track::-webkit-scrollbar{display:none}'
    + '.hz-lb__slide{flex:0 0 100%;height:100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;padding:64px 10px;box-sizing:border-box}'
    + '.hz-lb__slide img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;border-radius:6px;display:block}'
    + '.hz-lb button{all:unset;box-sizing:border-box;position:absolute;display:flex;align-items:center;justify-content:center;color:#fff;background:rgba(252,250,246,.16);border-radius:50%;cursor:pointer}'
    + '.hz-lb button svg{width:22px;height:22px}'
    + '.hz-lb .hz-lb__close{top:12px;right:12px;width:44px;height:44px}'
    + '.hz-lb .hz-lb__nav{top:50%;margin-top:-26px;width:52px;height:52px;display:none}'
    + '.hz-lb .hz-lb__nav--prev{left:24px}.hz-lb .hz-lb__nav--next{right:24px}'
    + '.hz-lb__count{position:absolute;top:24px;left:0;right:0;text-align:center;color:rgba(255,255,255,.8);font:500 14px/1 Poppins,sans-serif;pointer-events:none}'
    + '@media (min-width:750px){.hz-lb__slide{padding:56px 100px}.hz-lb .hz-lb__nav{display:flex}}'
    + '.product__modal-opener--image .product__media-toggle{cursor:zoom-in}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var CHEV = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  };
  var big = function (img) {
    var best = img.currentSrc || img.getAttribute('src') || '', bw = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
      var p = c.trim().split(/\s+/), w = parseInt(p[1], 10);
      if (p[0] && w > bw) { bw = w; best = p[0]; }
    });
    return best.replace(/([?&]width=)\d+/, function (m, k) { return k + '2000'; });
  };

  var lb, track, count, index = 0, n = 0, items = [];
  var mark = function () {
    index = Math.round(track.scrollLeft / track.clientWidth);
    count.textContent = (index + 1) + ' / ' + n;
  };
  var goTo = function (i) {
    i = ((i % n) + n) % n;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  };
  var close = function () {
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    // bring the page gallery to the photo that was open (phone slider)
    var li = items[index] && items[index].closest('li');
    var list = li && li.parentElement;
    if (list && list.scrollWidth > list.clientWidth + 4) list.scrollTo({ left: li.offsetLeft - list.offsetLeft });
  };
  var build = function () {
    lb = document.createElement('div');
    lb.className = 'hz-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="hz-lb__track"></div><div class="hz-lb__count"></div>'
      + '<button type="button" class="hz-lb__close" aria-label="' + T[0] + '">' + CHEV('M6 6l12 12M18 6L6 18') + '</button>'
      + '<button type="button" class="hz-lb__nav hz-lb__nav--prev" aria-label="' + T[1] + '">' + CHEV('M15 5l-7 7 7 7') + '</button>'
      + '<button type="button" class="hz-lb__nav hz-lb__nav--next" aria-label="' + T[2] + '">' + CHEV('M9 5l7 7-7 7') + '</button>';
    document.body.appendChild(lb);
    track = lb.querySelector('.hz-lb__track');
    count = lb.querySelector('.hz-lb__count');
    lb.querySelector('.hz-lb__close').addEventListener('click', close);
    lb.querySelector('.hz-lb__nav--prev').addEventListener('click', function () { goTo(index - 1); });
    lb.querySelector('.hz-lb__nav--next').addEventListener('click', function () { goTo(index + 1); });
    track.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') close(); });
    track.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', function () { if (lb.classList.contains('is-open')) track.scrollLeft = index * track.clientWidth; });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });
  };
  var open = function (openers, start) {
    if (!lb) build();
    items = openers;
    n = openers.length;
    track.innerHTML = openers.map(function (o) {
      var im = o.querySelector('img');
      return '<div class="hz-lb__slide">' + (im ? '<img src="' + big(im) + '" alt="' + (im.getAttribute('alt') || '').replace(/"/g, '&quot;') + '">' : '') + '</div>';
    }).join('');
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    track.scrollLeft = start * track.clientWidth;
    mark();
  };

  // capture phase: runs before the theme's <modal-opener>, so the old modal never opens
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product__modal-opener--image .product__media-toggle');
    if (!btn) return;
    var gallery = btn.closest('media-gallery') || btn.closest('.product__media-wrapper') || btn.closest('section') || document;
    var openers = [].filter.call(gallery.querySelectorAll('.product__modal-opener--image'), function (o) {
      var li = o.closest('li');
      return o.querySelector('img') && (!li || getComputedStyle(li).display !== 'none');
    });
    var start = openers.indexOf(btn.closest('.product__modal-opener--image'));
    if (start < 0 || !openers.length) return;
    e.preventDefault();
    e.stopPropagation();
    open(openers, start);
  }, true);
})();
